module.exports = __webpack_public_path__ + "static/media/37.b3cd16a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/37.png
// module id = 541
// module chunks = 0